/**
 * axios.js
 * @description: 封装AJAX请求
 * @author: glf
 * @date: 2019/1/8
 */

import axios from 'axios';
import i18n from "../i18n";

/**
 * 初始化 axios 一些统一的配置,
 * 支持一些配置:
 * 如 {
 *  mask: true (默认值: 遮罩id为body的节点) || false (不遮罩) || {sf-vue-compoent}(具有$mask方法的组件) || {dom} (dom节点)
 *  silent: 是否在请求失败的时候弹窗显示失败信息, true的时候不弹窗
 * }
 */

axios.interceptors.request.use(function (request) {
    let header = request.requestHeaders || {};
    request.headers = Object.assign(request.headers,header);
    return request;

}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    let lang = response.headers['accept-language'] || 'zh-CN';
    // let lang = "en-US";
    i18n.setLanguage(lang);
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default axios;
